import { z } from 'zod'

import { GlobalFieldSchema } from '../globalField'
import { NotificationReasonSchema } from '../notificationReason'
import { TagSchema } from '../tag'
import { UserFieldSchema } from '../userField'

import { AppSchema } from './app'
import { CustomEventSchema } from './customEvent'
import { DependenciesSchema } from './dependencies'
import { EntitiesSchema } from './entities'
import { IceBreakerSchema } from './iceBreaker'
import { ModelsSchema } from './models'

export const MapSchema = z.object({
  models: ModelsSchema,
  entities: EntitiesSchema,
  dependencies: DependenciesSchema,
  global_fields: z.array(GlobalFieldSchema),
  custom_fields: z.array(UserFieldSchema),
  custom_events: z.array(CustomEventSchema),
  apps: z.array(AppSchema),
  tags: z.array(TagSchema),
  otn_reasons: z.array(NotificationReasonSchema),
  ice_breakers: z.array(IceBreakerSchema),
})

export type Map = z.infer<typeof MapSchema>
